import { formatBytes } from './pdf.ts';

export function readFile(f: File): Promise<Uint8Array> {
  return f.arrayBuffer().then((b) => new Uint8Array(b));
}

export function isPdf(f: File) {
  return f.type === 'application/pdf' || /\.pdf$/i.test(f.name);
}

export function isImage(f: File) {
  return f.type.startsWith('image/');
}

/** 兼容旧调用方：`fmtBytes` 指向 `formatBytes`（lib/pdf.ts 的实现） */
export const fmtBytes = formatBytes;
